import { Injectable } from '@angular/core';
import { ApiHttpClient } from '../../../infrastructure/infrastructure.module';
import { Observable } from 'rxjs';
import { api } from '@bayclubs/utils'
import { camps } from '../../models/models.generated';

@Injectable()
export class CampEnrollmentApiService {

    constructor(private http: ApiHttpClient) { }

    public get(id: camps.Guid): Observable<api.OperationResultValue<camps.CampEnrollmentInfo>> {
        return this.http.get<api.OperationResultValue<camps.CampEnrollmentInfo>>(`enrollment/${id}`, true);
    }

    public sessions(request: camps.CampEnrollmentSessionsSearchRequest): Observable<api.OperationResultValue<camps.CampEnrollmentSessionsResponse>> {
        return this.http.post<api.OperationResultValue<camps.CampEnrollmentSessionsResponse>>(`enrollment/sessions`, request, false);
    }

    public getDayVariantDetails(id: camps.Guid): Observable<api.OperationResultValue<camps.CampEnrollmentSessionDaysVariantDetails>> {
        return this.http.get<api.OperationResultValue<camps.CampEnrollmentSessionDaysVariantDetails>>(`enrollment/sessions/daysvariant/${id}`, false);
    }
}
